import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { Project,DateTimeFormatPipe } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';
import { Studio, Job } from '@app/shared';

@Injectable()
export class ProjectService implements RequestService {


  redirectUrl: String = "";
  isBusy = false;
  private userUrl = 'campaign';  // URL to web api

  constructor(
    private http: HttpClient,
    private datePipe: DateTimeFormatPipe
    ) { }


  /** GET product by id. Will 404 if id not found */
  /** GET product by id. Will 404 if id not found */
  getProjects(keyword:string, status: string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let searchStr = keyword?keyword:'all';

    let project = window.location.href;
    const regex = /dashboard/g;
    let dashboard = String(project.match(regex));

    //const url = `${environment.baseURL}${this.userUrl}/${searchStr}?include=campaignRegions&sort=createdDate&dir=DESC`;
    let url = `${environment.baseURL}${this.userUrl}/${searchStr}?include=campaignRegions&sort=createdDate&dir=DESC&start=0&limit=50&status=${status}`;

    if(dashboard === 'dashboard')
      url = `${environment.baseURL}${this.userUrl}/${searchStr}?include=campaignRegions&sort=createdDate&dir=DESC&start=0`;
    //const url = `${environment.baseURL}${this.userUrl}/${searchStr}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  getProject(uuid:string): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.userUrl}/uuid/${uuid}?include=campaignStages.campaignDocuments.documentSegments&include=campaignStages.campaignDocuments&include=campaignStages.campaignDocuments.campaignRegions&include=campaignStages.campaignDocuments.documentSegments.pageDefinition`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  validateProject(code:string, uuid:string): Observable<any> {
    const url = `${environment.baseURL}${this.userUrl}/validate/code`;

    let urlSearchParams = new URLSearchParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    urlSearchParams.append('code',code);
    if(uuid)
      urlSearchParams.append('planUUID',uuid);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Project>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }

  updateProject(project:Project): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let action= project.uuid?'update':'create'
    const url = `${environment.baseURL}${this.userUrl}/${action}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();

    // Object.keys(project).forEach(function (key) {
    //   urlSearchParams.append(key, project[key]);
    // });
    let regions = project.campaignRegions.map(function(region) {
              return region['name'];
            });
    let startDate = this.datePipe.transform(project.startDate);
    let endDate = this.datePipe.transform(project.endDate);
    if(project.uuid){
      urlSearchParams.append('uuid',project.uuid);
    }
    urlSearchParams.append('code',project.code);

    urlSearchParams.append('name',project.name);
    urlSearchParams.append('startDate',startDate);
    urlSearchParams.append('endDate',endDate);
    if(project.pages)
      urlSearchParams.append('pages',project.pages.toString());
    if(regions && regions.length)
      urlSearchParams.append('regions',regions.toString());

    if(project.height)
      urlSearchParams.append('height',project.height.toString());

    if(project.width)
      urlSearchParams.append('width',project.width.toString());

    if(project.outputSize)
      urlSearchParams.append('outputSize',project.outputSize.toString());

    if(project.outputSize)
      urlSearchParams.append('unit',project.unit.toString());

    if(project.authoriserUUID)
      urlSearchParams.append('authoriserId',project.authoriserUUID.toString());

    if(project.projectmanagerUUID)
      urlSearchParams.append('projectmanagerId',project.projectmanagerUUID.toString());

    if(project.accountManagerUUID)
      urlSearchParams.append('accountManagerId',project.accountManagerUUID.toString());

    if(project.masterRegion)
      urlSearchParams.append('masterRegion',project.masterRegion);

    if(project.templateId)
      urlSearchParams.append('templateId',project.templateId);

    // if(project.businessBrandTag)
      urlSearchParams.append('businessBrandTag',project.businessBrandTag);

      urlSearchParams.append('fileDelivery',project.fileDelivery);	
      	
      urlSearchParams.append('studioPreference',project.studioPreference);

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Project>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })

  }

  // persons
  getPersons(keyword?:string): Observable<any> {

    const url = `${environment.baseURL}person/all`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  // document sub types
  getDocumentSubTypes(): Observable<any> {

    const url = `${environment.baseURL}document/subtype/all`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  // document sub types
  getPageLayouts(): Observable<any> {

    const url = `${environment.baseURL}pagelayout/all`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  // document sub types
  getMasterRegionTemplates(): Observable<any> {

    const url = `${environment.baseURL}masterregion/all`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  // document sub types
  getPageBackgrounds(): Observable<any> {

    const url = `${environment.baseURL}pagebackground/all`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(url,{
       //params : httpParams
       headers: headers
    })

  }

  getBusinessBrands(): Observable<any> {

    const url = `${environment.baseURL}company/businessBrands`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(url,{
       //params : httpParams
       headers: headers
    })

  }

  getStudioPref(): Observable<any> {		
    const url = `${environment.baseURL}studio/data`;		
    let httpParams = new HttpParams();		
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })		
    return this.http.get<any>(url,{		
       //params : httpParams		
       headers: headers		
    })		
  }

  generateProjectCSV(project:Project): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}campaign/${project.uuid}/csvreport`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'text/plain' })

    return this.http.get<Project>(url,{
       //params : httpParams
       headers: headers
    })

  }

  // document sub types
  getStudios(): Observable<any> {

    const url = `${environment.baseURL}studio/studios`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<any>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }

  assignStudiosToJob(code:string, studios:Studio[]): Observable<any> {
    const url = `${environment.baseURL}job/studios`;

    let urlSearchParams = new URLSearchParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let tmpStudios = studios.map(studio => studio.code);

    urlSearchParams.append('jobUUID',code);
    urlSearchParams.append('studios',tmpStudios.join(","));

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Project>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }

  assignStudiosToPage(code:string, studios:Studio[]): Observable<any> {
    let url = `${environment.baseURL}page/studios`;

    let urlSearchParams = new URLSearchParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let tmpStudios = studios.map(studio => studio.code);

    urlSearchParams.append('pageUUID',code);
    urlSearchParams.append('studios',tmpStudios.join(","));

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Project>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }

  assignStudiosToPages(number:string, studios:Studio[]): Observable<any> {

    let project = window.location.href;
    const regex = /[^\/]*$/g;
    let uuid = String(project.match(regex)[0]);

    let url = `${environment.baseURL}${this.userUrl}/${uuid}/studios`;

    let urlSearchParams = new URLSearchParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let tmpStudios = studios.map(studio => studio.code);
    urlSearchParams.append('pageNumber',number);
    urlSearchParams.append('studios',tmpStudios.join(","));

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Project>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })
  }

  sendManyPagesToStudio(jobs:Job[], pages:number[]): Observable<any> {
      let project = window.location.href;
      const regex = /[^\/]*$/g;
      let uuid = String(project.match(regex)[0]);
      
      var url = `${environment.baseURL}${this.userUrl}/${uuid}/jobjacket`;

      let urlSearchParams = new URLSearchParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      if(pages && pages.length){
        url += `/${pages.join(",")}`
      }

      return this.http.get<Project>(url,{
         //params : httpParams
         headers: headers
      })
  }

  sendPagesToStudio(jobs:Job[], pages:number[]): Observable<any> {
    // create an array of requests so that we can queue them with forkJoin
    const requests = jobs.map(job => {

      var url = `${environment.baseURL}job/${job.uuid}/jobjacket`;

      let urlSearchParams = new URLSearchParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      if(pages && pages.length){
        //urlSearchParams.append('pages',pages.join(","));
        url += `/${pages.join(",")}`
      }

      return this.http.get<Project>(url,{
         //params : httpParams
         headers: headers
      })
    });
    return Observable.forkJoin(requests);
  }

  retireProject(uuid:string): Observable<any> {
    const url = `${environment.baseURL}campaign/${uuid}/retire`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this.http.post<Project>(url, null, {
      headers: headers
    });
  }
  

  restoreProject(uuid:string): Observable<any> {
    const url = `${environment.baseURL}campaign/${uuid}/restore`;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    
    return this.http.post<Project>(url, null, {
      headers: headers
    });
  }

  loadProjectss(): Observable<any> {
    const body = { rt:'json'};
    const url = `${environment.baseURL}${this.userUrl}`;

    let projects = this.createProjects();
    return Observable.from(projects);

    // return new Observable((observer) => {
    //     // observable execution
    //     //this.selectedProject = new Project();
    //     //this.projects = [];
    //     let projects = this.createProjects();
    //     observer.next(projects);
    //
    //     observer.complete()
    // });

  }

  createProjects():Project[]{
    let projects = [];
    for(let i = 0; i < 10; i++){
      let proj = new Project();
      proj.name = `test {i}`;
      projects.push(proj);
    }
    return projects;

  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/project.service.ts